<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <valkyrie-list
      :list-data="usersListData"
      :pagination="usersListPagination"
      :pagination-text="paginationText"
      :list-name="'Users'"
      :headers.sync="headers"
      :is-loading="loading"
      rows-selectable
      @update-pagination="handleUpdatePagination"
      @select-row="selectRow"
    >
      <template v-slot:list-header>
        <default-list-header
          :searchable="searchable && hasDataToQuery"
          :exportable="exportable && hasDataToQuery"
          :pagination-text="paginationText"
          @search="handleUpdateSearch"
          @export-csv="exportCSV('Users')"
        />
      </template>
      <!-- eslint-disable vue/valid-v-slot -->
      <template #item.userOrgs="{ item }">
        <div v-if="item.orgs">
          <span>{{ item.orgs[0].name }}</span>
          <br>
          <span class="text--disabled text-caption">{{ item.orgs[0].id }}</span>
        </div>
        <span v-else>None</span>
      </template>
      <template slot="empty-state">
        <empty-state
          icon="$faUsers"
          text="No users found"
        />
      </template>
    </valkyrie-list>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import listMixin from '@/helpers/list-mixin'
  import paginationHelper from '@/helpers/pagination-helper'
  import ValkyrieList from '@/components/ValkyrieList.vue'
  import DefaultListHeader from '@/components/ValkyrieListDefaultHeader.vue'
  import EmptyState from '../../components/base/EmptyState.vue'
  import listControllerMixin from '@/helpers/list-controller-mixin'
  import { dateTimeSquasher } from '@/helpers/lists'

  export default {
    name: 'UsersList',
    components: { ValkyrieList, DefaultListHeader, EmptyState },
    mixins: [listMixin, listControllerMixin],
    props: {
      searchable: {
        type: Boolean,
        default: true,
      },
      exportable: {
        type: Boolean,
        default: true,
      },
      filterable: {
        type: Boolean,
        default: false,
      },
      hasFilters: {
        type: Boolean,
        default: false,
      },
      filterBy: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      loading: false,
      search: '',
      hasDataToQuery: false,
      payload: {
        listType: 'user',
        fileName: 'users.csv',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Phone',
          value: 'phone',
        },
        {
          text: 'Organization',
          value: 'userOrgs',
        },
        {
          text: 'Date Registered',
          value: 'createdAt',
        },
        {
          text: 'Number of Properties',
          value: 'numProperties',
        },
      ],
    }),
    computed: {
      ...mapGetters({ total: 'Users/usersListTotal' }),
      paginationText () {
        return paginationHelper(this.pageNum, this.perPage, this.total)
      },
      usersListData () {
        return this.listData.map((users) => {
          users.createdAt = dateTimeSquasher(users.createdAt)
          return users
        })
      },
      usersListPagination () {
        return { ...this.pagination, total: this.total }
      },
      listAPIPath () {
        return `${this.$store.state.baseURL}/user/list`
      },
    },
    created () {
      this.initializeUserList()
    },
    destroyed () { clearInterval(this.timeout) },
    methods: {
      initializeUserList () {
        this.fetchList().then((res) => {
          this.updateTotal(res.data.pagination.total)
          this.hasDataToQuery = res.data.pagination.total > 0
        })
      },
      updateTotal (total) {
        this.$store.commit('Users/updateUsersListTotal', total)
      },
      selectRow (item) {
        if (this.detail) return
        const checkRoute = this.$router.resolve({ path: `/users/${item.id}` })
        if (checkRoute.resolved.name !== '404 Error') {
          this.$router.push({ path: `/users/${item.id}` })
        }
      },
    },
  }
</script>
